module.exports = __webpack_public_path__ + "static/UNITY-TOWER-2nd-floor-modern_v2-436e2eb23dff12e38932d0941ca90f8b.pdf";